module.exports = __webpack_public_path__ + "static/media/praying-hands-solid-svgrepo-com.53e08630.svg";